import React, { Component } from "react";
import MajorIntroTop from "../MajorIntro/components/MajorIntroTop";
import MajorIntroItem from "../MajorIntro/components/MajorIntroItem";
import Shim from "../../components/Shim";
import "./style.css";
import { get } from "../../utils/request";
class MajorIntro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
    };
  }
  render() {
    const {
      majorName,
      level,
      mainCourse,
      trainGoal,
      kability,
      careerProspects,
    } = this.state.data;
    return (
      <div className="majorIntro_box">
        <MajorIntroTop marjorName={majorName} level={level}></MajorIntroTop>
        <MajorIntroItem
          title="培养目标"
          color="#c5c52b"
          content={trainGoal}
        ></MajorIntroItem>
        <MajorIntroItem
          title="主要课程"
          color="#eb7137"
          content={mainCourse}
        ></MajorIntroItem>
        <MajorIntroItem
          title="毕业生应具备的知识与能力"
          color="#68abeb"
          content={kability}
        ></MajorIntroItem>
        <MajorIntroItem
          title="就业情况"
          color="#eb7137"
          content={careerProspects}
        ></MajorIntroItem>
        <Shim></Shim>
      </div>
    );
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  componentWillMount() {
    this.requestMajorIntro();
  }
  /**
   * 请求专业列表
   */
  requestMajorIntro() {
    const id = this.props.match.params.id;
    get("/public/v1/major/intro/" + id).then((res) => {
      let dataSource = res.data;
      this.setState({
        data: dataSource,
      });
    });
  }
}

export default MajorIntro;



// WEBPACK FOOTER //
// ./src/containers/MajorIntro/index.js